import OBase from './OBase';

import * as Geometry from '../geometry';

export default class RemapNumbers extends OBase {
  update () {
    var vValTree = this.getFloatInput('Value');
    var sValTree = this.getIntervalObjectInput('Source');
    var tValTree = this.getIntervalObjectInput('Target');

    var mOutput = this.getGenericObjectOutput('Mapped');
    var cOutput = this.getGenericObjectOutput('Clipped');

    var dataTrees = [];
    var outDataTrees = [];
    dataTrees.push(vValTree);
    dataTrees.push(sValTree);
    dataTrees.push(tValTree);

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    var mOutTree = new Geometry.DataTree();
    var cOutTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        var vVal = outDataTrees[0].branches[i][j];
        var sVal = outDataTrees[1].branches[i][j];
        var tVal = outDataTrees[2].branches[i][j];

        let nVal = (vVal - sVal.min) / (sVal.max - sVal.min);
        var val = tVal.min + (tVal.max - tVal.min) * nVal;

        mOutTree.add(val, outDataTrees[0].paths[i]);
        cOutTree.add(val, outDataTrees[0].paths[i]);
      }
    }

    mOutput.value = mOutTree;
    cOutput.value = cOutTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/RemapNumbers.js